import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <div>Loading...</div>; // You can replace this with a spinner or custom loading component.
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />; // Redirect to home or login page.
  }

  return children;
};

export default ProtectedRoute;
